import { ReactComponent as LogoSvg } from "@/assets/svg/logo.svg";
import { Button, Link } from "./Buttons";
import { useLocation } from "react-router-dom";
import { useApp } from "@/hooks";
import { Fragment, useEffect, useState } from "react";
import { ReactComponent as HamburgerSvg } from "@/assets/svg/icon--hamburger.svg";
import clsx from "clsx";
import {
  Dialog,
  DialogPanel,
  Transition,
  TransitionChild,
} from "@headlessui/react";

export const Header = () => {
  const [isOpened, setOpened] = useState(false);
  const { screen } = useApp();
  const { pathname } = useLocation();

  useEffect(() => {
    setOpened(false);
  }, [screen, pathname]);

  if (screen === "") {
    return (
      <div className="realtive">
        <div className="relative z-50 container mx-auto bg-[#191a1f]">
          <div className="flex items-center justify-between py-4">
            <Link className="!px-0" to="/">
              <LogoSvg className="w-20 h-auto" />
            </Link>

            <button className="hamburger" onClick={() => setOpened(!isOpened)}>
              <HamburgerSvg />
            </button>
          </div>
        </div>

        <div className="absolute z-10">
          <Transition show={isOpened} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={setOpened}>
              <div className="fixed inset-0" />

              <div className="fixed inset-0 overflow-hidden">
                <div className="absolute inset-0 overflow-hidden">
                  <div className="pointer-events-none fixed inset-y-0 top-[85px]">
                    <TransitionChild
                      as={Fragment}
                      enter="transform transition ease-in-out duration-500"
                      enterFrom="-translate-y-full"
                      enterTo="translate-y-[0px]"
                      leave="transform transition ease-in-out duration-500"
                      leaveFrom="translate-y-[0px]"
                      leaveTo="-translate-y-full"
                    >
                      <DialogPanel className="pointer-events-auto w-screen max-w-md">
                        <div className="bg-third shadow-xl rounded-b-2xl">
                          <div className="flex flex-col items-center p-8 gap-5">
                            <div className="flex items-center justify-center gap-5">
                              <Link
                                className="px-2.5"
                                to="/pricing"
                                active={pathname.startsWith("/pricing")}
                              >
                                Pricing
                              </Link>

                              <Link
                                className="px-2.5"
                                to="/faqs"
                                active={pathname.startsWith("/faqs")}
                              >
                                FAQs
                              </Link>
                            </div>
                            <Button
                              outlined
                              className="w-52 !text-[#aee4e6] !border-[#aee4e6]"
                              href="https://www.intelliroom.ai"
                            >
                              Intelliroom.ai
                            </Button>
                            <Button
                              className="w-52"
                              href="https://www.app.t12.ai"
                            >
                              Login
                            </Button>
                          </div>
                        </div>
                      </DialogPanel>
                    </TransitionChild>
                  </div>
                </div>
              </div>
            </Dialog>
          </Transition>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto">
      <div className="flex items-center justify-between py-4">
        <Link className="!px-0" to="/">
          <LogoSvg className="w-20 h-auto" />
        </Link>

        <div className="flex items-center gap-5">
          <Link
            className="px-2.5"
            to="/pricing"
            active={pathname.startsWith("/pricing")}
          >
            Pricing
          </Link>

          <Link
            className="px-2.5"
            to="/faqs"
            active={pathname.startsWith("/faqs")}
          >
            FAQs
          </Link>

          <Button
            outlined
            className="w-52 !text-[#aee4e6] !border-[#aee4e6]"
            href="https://www.intelliroom.ai"
          >
            Intelliroom.ai
          </Button>
      
          <Button href="https://www.app.t12.ai">Login</Button>
        </div>
      </div>
    </div>
  );
};
